"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconSizeMap = void 0;
exports.iconSizeMap = {
    small: [16, 16],
    normal: [32, 32],
    medium: [20, 20],
    aboveAverage: [24, 24],
    sizeable: [28, 28],
    big: [36, 36],
};
